import Link from 'next/link'
import { STATS } from '@/lib/seoContent'

type LatestPost = { id: string; short_id?: string | null; title: string; date?: string | null }

const SPORT_LINKS: [string, string, string][] = [
  ['掼蛋', '/sports/guandan', '瑞士制 · 团团转 · 复式 · 联赛'],
  ['桥牌', '/sports/bridge', '米切尔 / 豪厄尔复式移位'],
  ['匹克球', '/sports/pickleball', '小组循环 + 淘汰 · 双打单打'],
  ['网球 / 羽毛球 / 乒乓球', '/sports/racquet', '球拍类锦标赛一键编排'],
  ['升级 / 双升 / 斗地主', '/sports/shengji', '扑克比赛编排与复式'],
]

const GUIDE_LINKS: [string, string][] = [
  ['掼蛋规则入门', '/guide/guandan-rules'],
  ['如何组织一场掼蛋比赛', '/guide/how-to-run-guandan'],
  ['瑞士制编排规则详解', '/guide/swiss-system'],
  ['团团转规则与记分', '/guide/tuantuanzhuan'],
  ['复式赛是什么', '/guide/duplicate'],
  ['米切尔 vs 豪厄尔', '/guide/mitchell-howell'],
  ['掼蛋计分与排名', '/guide/guandan-scoring'],
  ['小组循环 + 淘汰赛', '/guide/group-knockout'],
  ['联赛多站累计', '/guide/league'],
]

const CARD = 'rounded-2xl border border-solid border-white/10 bg-white/5 p-5 backdrop-blur'

// 首页服务端直出的一屏「平台说明 + 内链」:首页其余模块都是懒加载/客户端渲染,
// 没有这一块的话爬虫在首页只看得到标题。
const HomeSeoSection = ({ latest = [] }: { latest?: LatestPost[] }) => (
  <section aria-labelledby="home-about" className="flex flex-col gap-6 text-white">
    <div className="flex flex-col gap-2">
      <h2 id="home-about" className="m-0 text-2xl font-bold sm:text-3xl">
        灵缇赛事系统:棋牌与球拍类赛事的一站式编排计分平台
      </h2>
      <p className="max-w-4xl leading-relaxed text-white/75">
        从报名收费、扫码签到、一键编排、统一计时,到扫码录分、实时排名、证书与大屏投屏,一场比赛的全部流程都在这里完成。自 {STATS.since}
        上线,已承办 {STATS.matches} 场比赛、{STATS.teams} 支参赛队伍,注册用户 {STATS.users}。基础功能免费,网页、微信小程序与 App 通用。
      </p>
    </div>

    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-5">
      {SPORT_LINKS.map(([name, href, desc]) => (
        <Link key={href} href={href} className={`${CARD} flex flex-col gap-1 text-white hover:bg-white/10`}>
          <h3 className="m-0 text-lg font-semibold">{name}</h3>
          <span className="text-sm text-white/60">{desc}</span>
        </Link>
      ))}
    </div>

    <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">
      <div className={`${CARD} flex flex-col gap-3`}>
        <h3 className="m-0 text-lg font-semibold">办赛指南</h3>
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
          {GUIDE_LINKS.map(([label, href]) => (
            <Link key={href} href={href} className="text-sm text-white/80 hover:text-white">
              {label} →
            </Link>
          ))}
        </div>
        <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm">
          <Link href="/rules" className="text-orange-200 hover:text-white">
            竞赛规则库
          </Link>
          <Link href="/baike" className="text-orange-200 hover:text-white">
            赛事术语百科
          </Link>
          <Link href="/fushiji" className="text-orange-200 hover:text-white">
            复式发牌机
          </Link>
          <Link href="/manual" className="text-orange-200 hover:text-white">
            使用手册
          </Link>
        </div>
      </div>
      {latest.length > 0 && (
        <div className={`${CARD} flex flex-col gap-3`}>
          <div className="flex items-center justify-between">
            <h3 className="m-0 text-lg font-semibold">最新资讯</h3>
            <Link href="/news" className="text-sm text-orange-200 hover:text-white">
              全部 →
            </Link>
          </div>
          <ul className="flex flex-col gap-2">
            {latest.map((p) => (
              <li key={p.id} className="flex min-w-0 items-baseline gap-3 text-sm">
                {p.date && <span className="shrink-0 text-white/40">{p.date}</span>}
                <Link href={`/post/${p.short_id || p.id}`} className="truncate text-white/80 hover:text-white">
                  {p.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  </section>
)

export default HomeSeoSection
